import { displayFunctions } from '../../../utils/chartsUtils';

export const data = {
  plots: {
    impressions: {
      impressions: {
        trend: 1,
        values: [100, 120, 130, 140, 150, 160, 170],
        displayValue: displayFunctions.sum([100, 120, 130, 140, 150, 160, 170])
      }
    },
    followers: {
      followers: {
        trend: 1,
        values: [150, 200, 220, 240, 270, 290, 320],
        displayValue: 320
      },
      paid_followers: {
        trend: 1,
        values: [50, 70, 90, 100, 110, 120, 130],
        displayValue: 130
      },
      organic_followers: {
        trend: 1,
        values: [100, 130, 140, 160, 170, 180, 190],
        displayValue: 190
      }
    },
    follower_development: {
      new_followers: {
        trend: 1,
        values: [10, 15, 20, 18, 22, 25, 28],
        displayValue: 28
      }
    },
    page_views: {
      page_views: {
        trend: 1,
        values: [20, 25, 30, 35, 40, 45, 50],
        displayValue: displayFunctions.sum([20, 25, 30, 35, 40, 45, 50])
      },
      unique_page_views: {
        trend: 1,
        values: [15, 20, 22, 28, 32, 36, 40],
        displayValue: displayFunctions.sum([15, 20, 22, 28, 32, 36, 40])
      }
    }
  },
  additionalData: {
    posts_per_day: {
      trend: -1,
      values: [0, 0, 1, 0, 0, 2, 1],
      displayValue: 3
    }
  },
  dates: getLastSevenDays()
};

function getLastSevenDays(): any {
  const dates = [];
  for (let i = 1; i < 8; i++) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(date.toISOString().split('T')[0] + 'T00:00:00+00:00');
  }
  return dates.reverse();
}
